import { render } from 'preact';
import './styles/main.css';
import { App } from './app.jsx';

render(<App />, document.getElementById('app'));
